import { selectNearNode as _selectNearNode } from './commands';
import gapCursorKeymapPlugin from './pm-plugins/gap-cursor-keymap';
import gapCursorPlugin from './pm-plugins/gap-cursor-main';
import { gapCursorPluginKey } from './pm-plugins/gap-cursor-plugin-key';
import selectionKeymapPlugin from './pm-plugins/keymap';
import { createPlugin } from './pm-plugins/selection-main';
import { selectionPluginKey } from './types';
var displayGapCursor = function displayGapCursor(toggle) {
  return function (_ref) {
    var tr = _ref.tr;
    return tr.setMeta(gapCursorPluginKey, {
      displayGapCursor: toggle
    });
  };
};
export var selectionPlugin = function selectionPlugin(_ref2) {
  var options = _ref2.config;
  return {
    name: 'selection',
    commands: {
      displayGapCursor: displayGapCursor
    },
    actions: {
      selectNearNode: function selectNearNode(_ref3) {
        var selectionRelativeToNode = _ref3.selectionRelativeToNode,
          selection = _ref3.selection;
        return function (state) {
          return _selectNearNode(selectionRelativeToNode, selection)({
            tr: state.tr
          }) || state.tr;
        };
      }
    },
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return undefined;
      }
      var pluginState = selectionPluginKey.getState(editorState);
      return {
        selectionRelativeToNode: pluginState === null || pluginState === void 0 ? void 0 : pluginState.selectionRelativeToNode,
        selection: pluginState === null || pluginState === void 0 ? void 0 : pluginState.selection
      };
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'selection',
        plugin: function plugin(_ref4) {
          var dispatch = _ref4.dispatch,
            dispatchAnalyticsEvent = _ref4.dispatchAnalyticsEvent;
          return createPlugin(dispatch, dispatchAnalyticsEvent, options);
        }
      }, {
        name: 'selectionKeymap',
        plugin: selectionKeymapPlugin
      }, {
        name: 'gapCursorKeymap',
        plugin: function plugin() {
          return gapCursorKeymapPlugin();
        }
      }, {
        name: 'gapCursor',
        plugin: function plugin() {
          return gapCursorPlugin;
        }
      }];
    }
  };
};
export default selectionPlugin;